import gql from 'graphql-tag';
import React from 'react';
import { CreditCardWalletRowSummaryFields } from '../schemas/rql';
import CreditCardBrandIcon from './credit_card_brand_icon';

interface Props {
  creditCard: CreditCardWalletRowSummaryFields.CreditCards;
}

export default function CreditCardWalletRowSummary({ creditCard }: Props) {
  return (
    <div className="d-flex">
      <div className="width-rem-5">
        <CreditCardBrandIcon
          brand={creditCard.brand}
        />
      </div>
      <div className="pl-1">
        <div className="weight-bold">
          {creditCard.display.summary}
        </div>
        <div className="size-80">
          {creditCard.display.expirationDate}
        </div>
      </div>
    </div>
  );
}

export const CreditCardWalletRowSummaryFragment = gql`
  fragment CreditCardWalletRowSummaryFields on rql_Me {
    uuid
    creditCards {
      id
      primaryForCheckout
      display {
        summary
        expirationDate
      }
      brand {
        type
        name
      }
      address {
        name
        streetAddress
        extendedAddress
        locality
        regionName
        postalCode
        country {
          countryCode
        }
      }
    }
  }
`;
